<template>
  <v-btn text @click="$emit('click', $event)">
    <v-avatar size="20" class="mr-2">
      <img :src="require('../../assets/' + coloredAssetUrls.close)">
    </v-avatar>Close
  </v-btn>
</template>

<script>

export default {
  name: "CloseButton"
}
</script>
